import classNames from 'classnames';
import React from 'react';

import Button from 'common/components/Button';
import { LogoProps } from 'common/components/RewindModal';
import { useRewindContext } from 'common/components/RewindModal/RewindContext';
import { RewindConfig, RewindImages } from 'common/opes/loadOpes';
import { trackCaptifClickRewindModal } from 'common/tracking/rewindModal';

import styles from '../styles.module.scss';

type RewindCaptifProps = {
  ope?: RewindConfig;
  images?: RewindImages;
  headerLogo?: LogoProps;
  trackingScreenName?: string;
  flashbackType?: number;
};

const mockCovers = [
  'https://fr.web.img2.acsta.net/commons/v9/allocine/flashback/captif/captif-cover-1-ld.png',
  'https://fr.web.img2.acsta.net/commons/v9/allocine/flashback/captif/captif-cover-2-ld.png',
  'https://fr.web.img2.acsta.net/commons/v9/allocine/flashback/captif/captif-cover-3-ld.png',
  'https://fr.web.img2.acsta.net/commons/v9/allocine/flashback/captif/captif-cover-4-ld.png',
  'https://fr.web.img2.acsta.net/commons/v9/allocine/flashback/captif/captif-cover-5-ld.png',
  'https://fr.web.img2.acsta.net/commons/v9/allocine/flashback/captif/captif-cover-6-ld.png'
];

const RewindCaptif = ({
  ope,
  flashbackType: flashbackTypeProp,
  trackingScreenName
}: RewindCaptifProps) => {
  const { flashbackType: flashbackTypeContext, screenName } =
    useRewindContext();
  const flashbackType = flashbackTypeProp ?? flashbackTypeContext;
  const covers = ope?.provider?.covers ?? mockCovers;
  const logoUrl =
    ope?.provider?.logo_url ??
    'https://fr.web.img3.acsta.net/commons/v9/allocine/flashback/captif/logo-pathehome.png';
  const ctaLink =
    ope?.provider?.cta_link ??
    'https://www.pathehome.com/fr/fr?utm_source=Allocinecampaign&utm_medium=Allocineflashback&utm_campaign=flashback_allocine';

  const title = 'Le Flashback vous a plu ?';
  const subtitle = '(Re)découvrez vos coups de coeur 2025 sur';

  return (
    <div className={classNames(styles.contentLayout, styles.centeredLayout)}>
      <div
        className={classNames(
          styles.cardRow,
          styles.topCardRow,
          styles.topCards3,
          'nb-cards-3'
        )}
      >
        {covers.slice(0, 3).map((coverUrl: string, index: number) => (
          <div
            key={index}
            className={classNames(styles.card, styles.captifCover)}
          >
            <img src={coverUrl} alt={`Cover ${index + 1}`} />
          </div>
        ))}
      </div>
      <div className={styles.titleCenterWrapper}>
        <h2 className={styles.slideTitle}>{title}</h2>
        <h3 className={styles.slideText}>{subtitle}</h3>
        <img src={logoUrl} alt="Partenaire" className={styles.captifLogo} />

        <Button
          href={ctaLink}
          targetHref={true}
          size="sm"
          className={classNames(styles.captifCta, 'icon icon-play-arrow')}
          onClick={() => {
            trackCaptifClickRewindModal({
              flashbackType,
              screenName: (screenName || '') as ScreenNames,
              trackingScreenName
            });
          }}
        >
          Voir
        </Button>
      </div>

      <div
        className={classNames(
          styles.cardRow,
          styles.bottomCardRow,
          styles.topCards3,
          'nb-cards-3'
        )}
      >
        {covers.slice(3, 6).map((coverUrl: string, index: number) => (
          <div
            key={index}
            className={classNames(styles.card, styles.captifCover)}
          >
            <img src={coverUrl} alt={`Cover ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RewindCaptif;
